import { Box } from '@mui/material';
import React from 'react';

type GPTabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value?: number;
};

const GPTabPanel = ({ value = 0, index, children }: GPTabPanelProps) => (
  <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
    {value === index && <Box>{children}</Box>}
  </div>
);

export default GPTabPanel;
